import "./AutoSlider.css";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import slide1 from '../Images/slide1.png'
import slide2 from '../Images/slide2.png'
import slide3 from '../Images/slide3.png'
import { useMediaQuery } from "@mui/material";
import { useTheme } from '@mui/material/styles';

const AutoSlider = () => {


  const theme = useTheme()
  const isXs= useMediaQuery(theme.breakpoints.down('xs'));
  const isSm= useMediaQuery(theme.breakpoints.down('sm'));
  const isMd= useMediaQuery(theme.breakpoints.down('md'));

  const renderMobileAutoSlider = () => (
    <Swiper
    modules={[Navigation, Pagination, Scrollbar, Autoplay]}
    spaceBetween={50}
    slidesPerView={1}
    onSlideChange={() => console.log('slide change')}
    onSwiper={(swiper) => console.log(swiper)}
    pagination={{ clickable: true }}
    navigation={true}
    autoplay={{delay: 4000}}
    id="swiperContainerMobile"
    >
    <SwiperSlide>
      <img src={slide1} alt="slide" className="image" />
    </SwiperSlide>
    <SwiperSlide>
      <img src={slide2} alt="slide" className="image" />
    </SwiperSlide>
    <SwiperSlide>
      <img src={slide3} alt="slide" className="image" />
    </SwiperSlide>
    </Swiper>
  )

  const renderDesktopAutoSlider = () => (
    <Swiper
    modules={[Navigation, Pagination, Scrollbar, Autoplay]}
    spaceBetween={50}
    slidesPerView={1}
    onSlideChange={() => console.log('slide change')}
    onSwiper={(swiper) => console.log(swiper)}
    pagination={{ clickable: true }}
    navigation={true}
    autoplay={{delay: 4000}}
    id="swiperContainerDesktop"
    >
    <SwiperSlide>
      <img src={slide1} alt="slide" className="image" />
    </SwiperSlide>
    <SwiperSlide>
      <img src={slide2} alt="slide" className="image" />
    </SwiperSlide>
    <SwiperSlide>
      <img src={slide3} alt="slide" className="image" />
    </SwiperSlide>
    </Swiper>
  )

  return (
    <div>
        {
        (isXs) ?  renderMobileAutoSlider() : 
        (isSm) ? renderMobileAutoSlider() :
        (isMd) ? renderMobileAutoSlider() :
        renderDesktopAutoSlider()
      }
    </div>
  );
}

export default AutoSlider;